
import { Model } from 'backbone';

class EditorContentModel extends Model {

    initialize() {
    }

    defaults() {
        return {};
    }

}

export default EditorContentModel;
